import React from 'react';
import ConsentBanner from '../components/ConsentBanner';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { DefaultLayoutProps } from './DefaultLayout.types';

export const DefaultLayout: React.FC<DefaultLayoutProps> = ({
  isUserLoggedIn,
  children,
  showHeader,
  showFooter,
  showAppBanner,
}) => {
  const baseUrl = process.env.GATSBY_SPRINGD_HOST_URL;
  return (
    <>
      {<ConsentBanner showAppBanner={showAppBanner} />}
      {showHeader && (
        <Header baseUrl={baseUrl} isUserLoggedIn={isUserLoggedIn} />
      )}
      {children}
      {showFooter && <Footer baseUrl={baseUrl} />}
    </>
  );
};

export default DefaultLayout;
